// @ts-nocheck
import React, { useState, useRef } from 'react'
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import cx from 'classnames'

import { Button, Modal, ErrorIcon } from 'components/common'
import { signUp } from 'actions'
import s from './Register.module.css'

const Register = () => {
  const { error, isLoading } = useSelector((state) => state.auth)

  const errorModalRef = useRef()

  const [emailInput, setEmailInput] = useState()
  const [passwordInput, setPasswordInput] = useState()
  const [confirmPasswordInput, setConfirmPassowrdInput] = useState()

  const dispatch = useDispatch()

  const router = useRouter()

  const signUpHandler = (e) => {
    e.preventDefault()

    dispatch(
      signUp(
        emailInput,
        passwordInput,
        confirmPasswordInput,
        () => {
          localStorage.setItem('emailForAdditionalInfo', emailInput);
          router.push('/additionalInfo');
        },
        () => errorModalRef.current.openModal()
      )
    )
  }

  return (
    <div className={cx(s.container, 'content')}>
      <form onSubmit={signUpHandler}>
        <input
          type="email"
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          className={s.input}
          placeholder="E-mail"
          required
        />

        <input
          type="password"
          className={s.input}
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          placeholder="Password"
          required
          minLength={6}
        />

        <input
          type="password"
          className={s.input}
          value={confirmPasswordInput}
          onChange={(e) => setConfirmPassowrdInput(e.target.value)}
          placeholder="Confirm Password"
          required
          minLength={6}
        />

        <Button type="submit" text="Sign Up" isLoading={isLoading} />

        <Link href="/login">
          <a className={s.loginText}>
            Already have an account? <span style={{ color: 'blue' }}>Sign In</span>
          </a>
        </Link>

      </form>

      <Modal ref={errorModalRef} className="errorModalWrapper">
        <ErrorIcon className="errorIcon" />

        <div className="errorInfo">{error}</div>
      </Modal>
    </div>
  )
}

export default Register
